// Rien ne nomme une application en dur ici : elle appelle configureCommons au demarrage.

export interface NavLink {
  to: string
  label: string
}

export interface CommonsConfig {
  appName: string
  navLinks: NavLink[]
  adminLinks: NavLink[]
  sessionMinutes: number
}

const config: CommonsConfig = {
  appName: 'Application',
  navLinks: [],
  adminLinks: [],
  sessionMinutes: 5,
}

export function configureCommons(overrides: Partial<CommonsConfig>): void {
  Object.assign(config, overrides)
}

export function commonsConfig(): Readonly<CommonsConfig> {
  return config
}
